// import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
// import {
//   Table,
//   Layout,
//   Spin,
//   Checkbox,
//   Modal,
//   Space,
//   Button,
//   Select,
//   Card,
//   Row,
//   Col,
//   Typography,
//   Image,
// } from "antd";
// import axios from "axios";
// import { BaseUrl } from "../shared/BaseUrl";
// import QRCode from "qrcode.react";
// import { toast } from "react-toastify";
// import { DeleteTwoTone, RemoveRedEyeTwoTone } from "@mui/icons-material";
// import './Dashboard.css';

// const { Content } = Layout;
// const { Option } = Select;
// const { Title, Text } = Typography;

// export const Dashboard = () => {
//   const [qrCodeURL, setQRCodeURL] = useState("");
//   const [qrId, setQrId] = useState();
//   const [contents, setContents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentContentId, setCurrentContentId] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [contentToDelete, setContentToDelete] = useState(null);
//   const [selectedType, setSelectedType] = useState("audio");
//   const [selectedCategory, setSelectedCategory] = useState("Personal");
//   const [previewContent, setPreviewContent] = useState(null); // State for preview content
//   const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false); // State for preview modal
//   const token = localStorage.getItem("token");

//   const qrCodeRef = useRef();

//   useLayoutEffect(() => {
//     const fetchQr = async () => {
//       try {
//         const response = await axios.get(`${BaseUrl}/api/qrcode/user/qr`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         toast.success(response.data.message, {
//           position: "top-right",
//           autoClose: 3000,
//         });
//         setQRCodeURL(response.data.text);
//         setQrId(response.data._id);
//       } catch (error) {
//         console.error("Login error:", error.message);
//       }
//     };
//     fetchQr();
//   }, [token]);

//   useEffect(() => {
//     if (qrId) {
//       const fetchContents = async () => {
//         try {
//           const response = await axios.get(
//             `${BaseUrl}/api/content/contents/${qrId}`,
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );
//           setContents(response?.data?.contents);
//           setCurrentContentId(response?.data?.currentContent?._id);
//           setLoading(false);
//         } catch (error) {
//           console.error("Fetch content error:", error.message);
//           setLoading(false);
//         }
//       };
//       fetchContents();
//     }
//   }, [qrId, token]);

//   const handleContentTypeChange = (value) => {
//     setSelectedType(value);
//   };

//   const handleCheckboxChange = async (checked, record) => {
//     if (checked) {
//       setIsModalOpen(true);
//       setCurrentContentId(record._id);
//     } else {
//       setCurrentContentId(null);
//     }
//   };

//   const handleOk = async () => {
//     const response = await axios.post(
//       `${BaseUrl}/api/content/set/${currentContentId}`,
//       { qrId: qrId },
//       {
//         headers: { Authorization: `Bearer ${token}` },
//       }
//     );
//     toast.success(response.data.message, {
//       position: "top-right",
//       autoClose: 3000,
//     });
//     setIsModalOpen(false);
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//   };

//   const handleDelete = async (contentId) => {
//     try {
//       const response = await axios.delete(
//         `${BaseUrl}/api/content/delete/${contentId}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       toast.success(response.data.message, {
//         position: "top-right",
//         autoClose: 3000,
//       });
//       setContents(contents.filter((item) => item._id !== contentId));
//     } catch (error) {
//       console.error("Delete content error:", error.message);
//     }
//   };

//   const handleDeleteOk = () => {
//     if (contentToDelete) {
//       handleDelete(contentToDelete);
//       setIsDeleteModalOpen(false);
//     }
//   };

//   const handleDeleteCancel = () => {
//     setIsDeleteModalOpen(false);
//   };

//   // Function to handle preview
//   const handlePreview = (record) => {
//     setPreviewContent(record);
//     setIsPreviewModalOpen(true);
//   };

//   // Function to close the preview modal
//   const handlePreviewCancel = () => {
//     setIsPreviewModalOpen(false);
//   };

//   // Custom footer for the Confirm Selection Modal
//   const confirmSelectionFooter = (
//     <div style={{ display: "flex", justifyContent: "flex-end" }}>
//       <Button key="cancel" onClick={handleCancel}>
//         Cancel
//       </Button>
//       <Button
//         key="ok"
//         type="primary"
//         onClick={handleOk}
//         style={{ marginLeft: "8px" }}
//       >
//         Set Content
//       </Button>
//     </div>
//   );

//   const columns = [
//     {
//       title: "ID",
//       key: "index",
//       render: (text, record, index) => index + 1,
//     },
//     {
//       title: "Text",
//       dataIndex: "text",
//       key: "text",
//       render: (text) => (text ? text : <b>N/A</b>),
//     },
//     {
//       title: "Label",
//       dataIndex: "label",
//       key: "label",
//       render: (label) => (label ? <b> {label}</b> : <b>N/A</b>),
//     },
//     {
//       title: "Upload Time",
//       dataIndex: "createdAt",
//       key: "createdAt",
//     },
//     {
//       title: "View",
//       key: "action",
//       render: (text, record) => (
//         <Space size="middle">
//           <Button type="link" onClick={() => handlePreview(record)}>
//             <RemoveRedEyeTwoTone />
//           </Button>
//         </Space>
//       ),
//     },
//     {
//       title: "Delete",
//       key: "delete",
//       render: (text, record) => (
//         <Space size="middle">
//           <DeleteTwoTone
//             style={{ color: "#ff4d4f", cursor: "pointer" }}
//             onClick={() => {
//               setIsDeleteModalOpen(true);
//               setContentToDelete(record._id);
//             }}
//           />
//         </Space>
//       ),
//     },
//     {
//       title: "Select",
//       key: "checkbox",
//       render: (text, record) => (
//         <Checkbox
//           checked={record._id === currentContentId}
//           onChange={(e) => handleCheckboxChange(e.target.checked, record)}
//         />
//       ),
//     },
//   ];

//   const contentMapping = {
//     audio: contents.filter(
//       (content) =>
//         content.contentType === "audio" && content.category === selectedCategory
//     ),
//     video: contents.filter(
//       (content) =>
//         content.contentType === "video" && content.category === selectedCategory
//     ),
//     image: contents.filter(
//       (content) =>
//         content.contentType === "image" && content.category === selectedCategory
//     ),
//     text: contents.filter(
//       (content) =>
//         content.contentType === "text" && content.category === selectedCategory
//     ),
//   };

//   const handleDownloadQRCode = () => {
//     const canvas = qrCodeRef.current.querySelector("canvas");
//     const pngUrl = canvas
//       .toDataURL("image/png")
//       .replace("image/png", "image/octet-stream");
//     let downloadLink = document.createElement("a");
//     downloadLink.href = pngUrl;
//     downloadLink.download = "qr_code.png";
//     document.body.appendChild(downloadLink);
//     downloadLink.click();
//     document.body.removeChild(downloadLink);
//   };

//   return (
//     <Layout style={{ padding: "24px", background: "transparent" }}>
//       {loading ? (
//         <Spin
//           tip="Loading..."
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             height: "100vh",
//           }}
//         />
//       ) : (
//         <>
//    <Card
//             style={{
//               marginBottom: "24px",
//               borderRadius: "8px",
//               border: "2px solid",
//               borderImageSource: "linear-gradient(107.77deg, #FFD600 8.57%, rgba(0, 0, 0, 0.25) 23.6%, rgba(0, 0, 0, 0.25) 65.5%, #BF7901 94.73%)",
//               background: "linear-gradient(99.99deg, rgba(241, 210, 64, 0.55) 10.36%, rgba(0, 0, 0) 94.72%)",
//             }}
//             bodyStyle={{ padding: "24px" }}
//           >
//             <div style={{width:"100%", background:"linear-gradient(99.99deg, rgba(241, 210, 64, 0.55) 10.36%, rgba(0, 0, 0) 94.72%)", borderRadius: "8px", padding: "24px", marginBottom: "24px" }}>
//             <Title level={1} style={{color:'#FFFFFF'}}>Dashboard</Title>
//             <Text type="primary" style={{ fontSize: "16px", color:"#FFFFFF" }}>
//               Manage your QR code and content here.
//             </Text>
//             </div>
//           </Card>

//           <Row gutter={[24, 24]}>
//             <Col xs={24} md={12}>
//               <Card
//                 title={<span style={{ color: '#FFFFFF' }}>QR Code</span>}
//                 style={{
//                   borderRadius: "8px",
//                   border: "2px solid",
//                   borderImageSource: "linear-gradient(107.77deg, #FFD600 8.57%, rgba(0, 0, 0, 0.25) 23.6%, rgba(0, 0, 0, 0.25) 65.5%, #BF7901 94.73%)",
//                   background: "linear-gradient(99.99deg, rgba(241, 210, 70, 0.69) 10.36%, rgba(0, 0, 0) 94.72%)",
//                 }}
//                 bodyStyle={{ textAlign: "center", color: "#FFFFFF" }}
//               >
//                 <div ref={qrCodeRef} style={{ margin: "auto" }}>
//                   <QRCode value={qrCodeURL} size={window.innerWidth < 768 ? 150 : 200} />
//                 </div>
//                 <button
//                   type="primary"
//                   style={{ marginTop: "16px", width: "100%", maxWidth: "200px" }}
//                   onClick={handleDownloadQRCode}
//                 >
//                   Download QR
//                 </button>
//               </Card>
//             </Col>

//             <Col xs={24} md={12}>
//               <Card
//                 title={<span style={{ color: '#FFFFFF' }}>Filters</span>}
//                 style={{
//                   borderRadius: "8px",
//                   border: "2px solid",
//                   borderImageSource: "linear-gradient(107.77deg, #FFD600 8.57%, rgba(0, 0, 0, 0.25) 23.6%, rgba(0, 0, 0, 0.25) 65.5%, #BF7901 94.73%)",
//                   background: "linear-gradient(99.99deg, rgba(241, 210, 64, 0.55) 10.36%, rgba(0, 0, 0) 94.72%)",
//                 }}
//                 bodyStyle={{ padding: "24px" }}
//               >
//                 <Select
//                   defaultValue="audio"
//                   style={{ width: "100%", marginBottom: "16px" }}
//                   onChange={handleContentTypeChange}
//                 >
//                   <Option value="audio">Audio</Option>
//                   <Option value="video">Video</Option>
//                   <Option value="image">Image</Option>
//                   <Option value="text">Text</Option>
//                 </Select>

//                 <Select
//                   defaultValue="Personal"
//                   style={{ width: "100%" }}
//                   onChange={(value) => setSelectedCategory(value)}
//                 >
//                   <Option value="Personal">Personal</Option>
//                   <Option value="Family">Family</Option>
//                   <Option value="Party">Party</Option>
//                   <Option value="Work">Work</Option>
//                   <Option value="Other">Other</Option>
//                 </Select>
//               </Card>
//             </Col>
//           </Row>

//           <Card
//             style={{
//               marginTop: "24px",
//               borderRadius: "8px",
//               background: "linear-gradient(99.99deg, rgba(241, 210, 64, 0.55) 10.36%, rgba(0, 0, 0) 94.72%)",
//             }}
//             bodyStyle={{ padding: "24px" }}
//           >
//             <Table
//               columns={columns}
//               dataSource={contentMapping[selectedType]}
//               rowKey={(record) => record._id}
//               pagination={{ pageSize: 5 }}
//               scroll={{ x: true }}
//               style={{ fontSize: window.innerWidth < 768 ? "12px" : "14px" }}
//             />
//           </Card>

//           {/* Preview Modal */}
//           <Modal
//             title="Content Preview"
//             open={isPreviewModalOpen}
//             onCancel={handlePreviewCancel}
//             footer={null}
//             width={800}
//           >
//             {previewContent && (
//               <div>
//                 {previewContent.contentType === "image" && (
//                   <Image
//                     src={previewContent.contentUrl}
//                     alt="Preview"
//                     style={{ width: "100%" }}
//                   />
//                 )}
//                 {previewContent.contentType === "video" && (
//                   <video controls style={{ width: "100%" }}>
//                     <source src={previewContent.contentUrl} type="video/mp4" />
//                     Your browser does not support the video tag.
//                   </video>
//                 )}
//                 {previewContent.contentType === "audio" && (
//                   <audio controls style={{ width: "100%" }}>
//                     <source src={previewContent.contentUrl} type="audio/mpeg" />
//                     Your browser does not support the audio tag.
//                   </audio>
//                 )}
//                 {previewContent.contentType === "text" && (
//                   <p>{previewContent.text}</p>
//                 )}
//               </div>
//             )}
//           </Modal>

//           {/* Confirm Selection Modal */}
//           <Modal
//             title="Confirm Selection"
//             open={isModalOpen}
//             onOk={handleOk}
//             onCancel={handleCancel}
//             footer={confirmSelectionFooter} // Use custom footer
//           >
//             <p>
//               Are you sure you want to select this content as the default for
//               your QR code?
//             </p>
//           </Modal>

//           {/* Confirm Deletion Modal */}
//           <Modal
//             title="Confirm Deletion"
//             open={isDeleteModalOpen}
//             onOk={handleDeleteOk}
//             onCancel={handleDeleteCancel}
//             okText="Delete"
//           >
//             <p>Are you sure you want to delete this content?</p>
//           </Modal>
//         </>
//       )}
//     </Layout>
//   );
// };
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import {
  Table,
  Layout,
  Spin,
  Checkbox,
  Modal,
  Space,
  Button,
  Select,
  Card,
  Image,
  Input,
} from "antd";
import axios from "axios";
import { BaseUrl } from "../shared/BaseUrl";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "react-toastify";
import { DeleteTwoTone, RemoveRedEyeTwoTone } from "@mui/icons-material";
import { FiActivity, FiCheckSquare, FiDatabase, FiRotateCcw, FiSearch, FiUsers } from "react-icons/fi";
import './Dashboard.css';

const { Option } = Select;

export const Dashboard = () => {
  const [qrCodeURL, setQRCodeURL] = useState("");
  const [qrId, setQrId] = useState();
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentContentId, setCurrentContentId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [contentToDelete, setContentToDelete] = useState(null);
  const [selectedType, setSelectedType] = useState("All"); // Default to "All"
  const [selectedCategory, setSelectedCategory] = useState("All"); // Default to "All"
  const [selectedSecurity, setSelectedSecurity] = useState("All"); // New state for security filter
  const [selectedContentType, setSelectedContentType] = useState("All"); // New state for content type filter
  const [searchTerm, setSearchTerm] = useState("");
  const [previewContent, setPreviewContent] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [scanSummary, setScanSummary] = useState({
    totalScans: 0,
    uniqueVisitors: 0,
  });
  const token = localStorage.getItem("token");
  const getApiErrorMessage = (error, fallbackMessage) => {
    return (
      error?.response?.data?.message ||
      error?.message ||
      fallbackMessage
    );
  };

  const qrCodeRef = useRef();

  useLayoutEffect(() => {
    const fetchQr = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/api/qrcode/user/qr`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setQRCodeURL(response.data.text);
        setQrId(response.data._id);
        setScanSummary({
          totalScans: Number(response?.data?.totalScans || 0),
          uniqueVisitors: Number(response?.data?.uniqueVisitors || 0),
        });
      } catch (error) {
        console.error("Login error:", error.message);
        toast.error(
          getApiErrorMessage(error, "Unable to fetch your QR code."),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      }
    };
    fetchQr();
  }, [token]);

  useEffect(() => {
    const fetchScanSummary = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/api/content/scans/summary`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const summary = response?.data?.summary || {};
        setScanSummary({
          totalScans: Number(summary.totalScans || 0),
          uniqueVisitors: Number(summary.uniqueVisitors || 0),
        });
      } catch (error) {
        // Non-blocking, dashboard falls back to content-level counters.
      }
    };

    if (token) {
      fetchScanSummary();
    }
  }, [token]);

  useEffect(() => {
    if (qrId) {
      const fetchContents = async () => {
        try {
          const response = await axios.get(
            `${BaseUrl}/api/content/contents/${qrId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          setContents(response?.data?.contents);
          setCurrentContentId(response?.data?.currentContent?._id);
          setLoading(false);
        } catch (error) {
          console.error("Fetch content error:", error.message);
          toast.error(
            getApiErrorMessage(error, "Unable to fetch content list."),
            {
              position: "top-right",
              autoClose: 3000,
            }
          );
          setLoading(false);
        }
      };
      fetchContents();
    }
  }, [qrId, token]);

  const handleContentTypeChange = (value) => {
    setSelectedType(value);
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };

  const handleSecurityChange = (value) => {
    setSelectedSecurity(value);
  };

  const handleContentTypeFilterChange = (value) => {
    setSelectedContentType(value);
  };

  const handleResetFilters = () => {
    setSelectedType("All");
    setSelectedCategory("All");
    setSelectedSecurity("All");
    setSelectedContentType("All");
    setSearchTerm("");
  };

  const handleCheckboxChange = async (checked, record) => {
    if (checked) {
      setIsModalOpen(true);
      setCurrentContentId(record._id);
    } else {
      setCurrentContentId(null);
    }
  };

  const handleOk = async () => {
    try {
      const response = await axios.post(
        `${BaseUrl}/api/content/set/${currentContentId}`,
        { qrId: qrId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (error) {
      toast.error(
        getApiErrorMessage(error, "Unable to set current content."),
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setIsModalOpen(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDelete = async (contentId) => {
    try {
      const response = await axios.delete(
        `${BaseUrl}/api/content/delete/${contentId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 3000,
      });
      setContents(contents.filter((item) => item._id !== contentId));
    } catch (error) {
      console.error("Delete content error:", error.message);
      toast.error(
        getApiErrorMessage(error, "Unable to delete content."),
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };

  const handleDeleteOk = () => {
    if (contentToDelete) {
      handleDelete(contentToDelete);
      setIsDeleteModalOpen(false);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  const handlePreview = (record) => {
    setPreviewContent(record);
    setIsPreviewModalOpen(true);
  };

  const handlePreviewCancel = () => {
    setIsPreviewModalOpen(false);
  };

  const confirmSelectionFooter = (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <Button key="cancel" onClick={handleCancel}>
        Cancel
      </Button>
      <Button
        key="ok"
        type="primary"
        onClick={handleOk}
        style={{ marginLeft: "8px" }}
      >
        Set Content
      </Button>
    </div>
  );

  const columns = [
    {
      title: "QR Name",
      key: "name",
      render: (_, record) => (
        <span className="dashboard-table-name">
          {record.label || record.text || "Untitled QR"}
        </span>
      ),
    },
    {
      title: "Type",
      key: "type",
      render: (_, record) => {
        const typeLabel = record.contentType
          ? `${record.contentType.charAt(0).toUpperCase()}${record.contentType.slice(1)}`
          : "N/A";
        return (
          <span className="dashboard-table-type">
            {record.category ? `${typeLabel} ${record.category}` : typeLabel}
          </span>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (
        <span className="dashboard-table-date">{formatDateValue(createdAt)}</span>
      ),
    },
    {
      title: "Status",
      key: "status",
      render: (_, record) => {
        const tone = getStatusTone(record);
        const label = tone === "active" ? "Active" : tone === "verifying" ? "Verifying" : "Paused";
        return (
          <span className={`dashboard-status-pill ${tone}`}>
            <i />
            {label}
          </span>
        );
      },
    },
    {
      title: "",
      key: "action",
      width: 150,
      render: (_, record) => (
        <Space size="small" className="dashboard-row-actions">
          <Button type="link" onClick={() => handlePreview(record)}>
            <RemoveRedEyeTwoTone />
          </Button>
          <DeleteTwoTone
            style={{ color: "#ff4d4f", cursor: "pointer" }}
            onClick={() => {
              setIsDeleteModalOpen(true);
              setContentToDelete(record._id);
            }}
          />
          <Checkbox
            checked={record._id === currentContentId}
            onChange={(e) => handleCheckboxChange(e.target.checked, record)}
          />
        </Space>
      ),
    },
  ];

  function formatDateValue(value) {
    if (!value) {
      return "N/A";
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return value;
    }
    return parsed.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  const filteredContents = contents.filter((content) => {
    const lifecycleType = content.type || (content.isTemporary ? "temporary" : "permanent");
    const normalizedSearch = searchTerm.trim().toLowerCase();
    const searchableText = [
      content.label,
      content.text,
      content.category,
      content.contentType,
      lifecycleType,
      content._id,
      formatDateValue(content.createdAt),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    const matchesType = selectedType === "All" || content.contentType === selectedType;
    const matchesCategory = selectedCategory === "All" || content.category === selectedCategory;
    const matchesSecurity = selectedSecurity === "All" || content.isSecure === (selectedSecurity === "Secure");
    const matchesContentType = selectedContentType === "All" || lifecycleType === selectedContentType;
    const matchesSearch = !normalizedSearch || searchableText.includes(normalizedSearch);
    return matchesType && matchesCategory && matchesSecurity && matchesContentType && matchesSearch;
  });

  const totalQRCodes = contents.length;
  const derivedScanCount = contents.reduce(
    (sum, item) => sum + Number(item.scanCount || item.totalScans || 0),
    0
  );
  const derivedUniqueVisitors = contents.reduce(
    (sum, item) => sum + Number(item.uniqueVisitorCount || 0),
    0
  );
  const totalScans = Number(scanSummary.totalScans || 0) || derivedScanCount;
  const uniqueUsersReached =
    Number(scanSummary.uniqueVisitors || 0) || derivedUniqueVisitors;
  const activeQRCodes = contents.filter(
    (item) => item._id === currentContentId || item.status === "active"
  ).length;

  const formatMetric = (value) => {
    if (!value) {
      return "0";
    }
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `${Math.round(value / 100) / 10}K`;
    }
    return `${value}`;
  };

  const getStatusTone = (record) => {
    if (record._id === currentContentId) {
      return "active";
    }
    if (record.isTemporary) {
      return "verifying";
    }
    return "paused";
  };

  const handleDownloadQRCode = () => {
    const canvas = qrCodeRef.current.querySelector("canvas");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qr_code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const performanceCards = [
    {
      label: "QR Contents",
      value: formatMetric(totalQRCodes),
      icon: FiDatabase,
    },
    {
      label: "Scans",
      value: formatMetric(totalScans),
      icon: FiActivity,
    },
    {
      label: "Unique Users Reached",
      value: formatMetric(uniqueUsersReached),
      icon: FiUsers,
    },
    {
      label: "QR Codes Active",
      value: formatMetric(activeQRCodes),
      icon: FiCheckSquare,
    },
  ];

  return (
    <Layout className="dashboard-layout">
      {loading ? (
        <div className="dashboard-loading">
          <Spin tip="Loading..." />
        </div>
      ) : (
        <>

                  <section className="dashboard-tools-row dashboard-tools-single">
            <Card
              title={<span>Your QR Code</span>}
              className="dashboard-card dashboard-qr-card"
            >
              <div ref={qrCodeRef} className="dashboard-qr-wrap">
                <QRCodeCanvas
                  value={qrCodeURL}
                  size={window.innerWidth < 768 ? 150 : 280}
                />
              </div>
              <button
                type="button"
                className="dashboard-qr-btn"
                onClick={handleDownloadQRCode}
              >
                Download QR
              </button>
            </Card>
          </section>

          
          <section className="dashboard-overview-section">
            <h2 className="dashboard-section-title">Your Performance Overview</h2>
            <div className="dashboard-stat-grid">
              {performanceCards.map((card) => {
                const Icon = card.icon;
                return (
                  <article key={card.label} className="dashboard-stat-card">
                    <span className="dashboard-stat-icon">
                      <Icon />
                    </span>
                    <div>
                      <h3>{card.value}</h3>
                      <p>{card.label}</p>
                    </div>
                  </article>
                );
              })}
            </div>
          </section>



          <section className="dashboard-table-section">
            <div className="dashboard-table-header">
              <h2 className="dashboard-section-title">Recent QR Activity</h2>
              <span className="dashboard-results-pill">
                {filteredContents.length} result{filteredContents.length === 1 ? "" : "s"}
              </span>
            </div>
            <div className="dashboard-table-toolbar">
              <Input
                allowClear
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
                placeholder="Search by name, text, category, type, or date"
                prefix={<FiSearch />}
                className="dashboard-search-input"
              />

              <div className="dashboard-toolbar-filters">
                <Select
                  value={selectedType}
                  className="dashboard-toolbar-select"
                  onChange={handleContentTypeChange}
                  dropdownClassName="dashboard-filter-dropdown"
                >
                  <Option value="All">All Types</Option>
                  <Option value="audio">Audio</Option>
                  <Option value="video">Video</Option>
                  <Option value="image">Image</Option>
                  <Option value="text">Text</Option>
                </Select>

                <Select
                  value={selectedCategory}
                  className="dashboard-toolbar-select"
                  onChange={handleCategoryChange}
                  dropdownClassName="dashboard-filter-dropdown"
                >
                  <Option value="All">All Categories</Option>
                  <Option value="Personal">Personal</Option>
                  <Option value="Family">Family</Option>
                  <Option value="Party">Party</Option>
                  <Option value="Work">Work</Option>
                  <Option value="Other">Other</Option>
                </Select>

                <Select
                  value={selectedSecurity}
                  className="dashboard-toolbar-select"
                  onChange={handleSecurityChange}
                  dropdownClassName="dashboard-filter-dropdown"
                >
                  <Option value="All">All Security</Option>
                  <Option value="Secure">Secure</Option>
                  <Option value="Not Secure">Not Secure</Option>
                </Select>

                <Select
                  value={selectedContentType}
                  className="dashboard-toolbar-select"
                  onChange={handleContentTypeFilterChange}
                  dropdownClassName="dashboard-filter-dropdown"
                >
                  <Option value="All">All Content Types</Option>
                  <Option value="permanent">Permanent</Option>
                  <Option value="temporary">Temporary</Option>
                </Select>

                <button
                  type="button"
                  className="dashboard-reset-filters-btn"
                  onClick={handleResetFilters}
                >
                  <FiRotateCcw />
                  Reset
                </button>
              </div>
            </div>
            <Card className="dashboard-card dashboard-table-card">
              <Table
                columns={columns}
                dataSource={filteredContents}
                rowKey={(record) => record._id}
                pagination={false}
                rowClassName={() => "dashboard-table-row"}
                scroll={{ x: 960, y: 360 }}
                locale={{ emptyText: <span className="dashboard-empty">No activity yet.</span> }}
              />
            </Card>
          </section>

          {/* Preview Modal */}
          <Modal
            title="Content Preview"
            open={isPreviewModalOpen}
            onCancel={handlePreviewCancel}
            footer={null}
            width={800}
          >
            {previewContent && (
              <div>
                {previewContent.contentType === "image" && (
                  <Image
                    src={previewContent.contentUrl}
                    alt="Preview"
                    style={{ width: "100%" }}
                  />
                )}
                {previewContent.contentType === "video" && (
                  <video controls style={{ width: "100%" }}>
                    <source src={previewContent.contentUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
                {previewContent.contentType === "audio" && (
                  <audio controls style={{ width: "100%" }}>
                    <source src={previewContent.contentUrl} type="audio/mpeg" />
                    Your browser does not support the audio tag.
                  </audio>
                )}
                {previewContent.contentType === "text" && (
                  <p>{previewContent.text}</p>
                )}
              </div>
            )}
          </Modal>

          {/* Confirm Selection Modal */}
          <Modal
            title="Confirm Selection"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={confirmSelectionFooter}
          >
            <p>
              Are you sure you want to select this content as the default for
              your QR code?
            </p>
          </Modal>

          {/* Confirm Deletion Modal */}
          <Modal
            title="Confirm Deletion"
            open={isDeleteModalOpen}
            onOk={handleDeleteOk}
            onCancel={handleDeleteCancel}
            okText="Delete"
          >
            <p>Are you sure you want to delete this content?</p>
          </Modal>
        </>
      )}
    </Layout>
  );
};
